import { RepositoryFactory } from '@/api/RepositoryFactory';
import { ActionTree, Module } from 'vuex';
import ActuatorRepository from '@/api/ActuatorRepository';
import Actuator from '@/models/Actuator';
import { ActuatorState } from '@/store/storeStateInterface';
import Project from '@/models/Project';
import Revision from '@/models/Revision';

const actuatorRepository: ActuatorRepository = RepositoryFactory.get('actuator');

const store: ActuatorState = {
    allActuators: []
};

const actions: ActionTree<any, any> = {
    getActuatorAction: async (_, payload: { actuatorId: string }): Promise<Actuator> => {
        const actuatorData = await actuatorRepository.getActuator(payload.actuatorId);
        return Actuator.parseFromObject(actuatorData);

    },
    getAllActuatorsAction: async ({ commit }, payload: { project: Project }): Promise<Actuator[]> => {
        const actuatorData = await actuatorRepository.getAllActuators(payload.project.id);
        const actuators = Actuator.parseFromObject(actuatorData) as unknown as Actuator[];
        commit('saveAllActuators', { actuators });
        return actuators;
    },
    createActuatorAction: async (_, payload: { project: Project, revision?: Revision, actuator: Actuator }): Promise<Actuator> => {
        const actuatorData = await actuatorRepository.createActuator(payload.project, payload.revision, payload.actuator);
        return Actuator.parseFromObject(actuatorData);
    },
    updateActuatorAction: async ({ commit }, payload: { actuator: Actuator }): Promise<Actuator> => {
        await actuatorRepository.updateActuator(payload.actuator);
        // Keep the currently edited row as source of truth in UI to avoid
        // stale response payloads reverting user input while typing.
        commit('updateActuator', { actuator: payload.actuator });
        commit('settings/updateProjectActuator', { actuator: payload.actuator }, { root: true });
        return payload.actuator;
    },
    deleteActuatorAction: async (_, payload: { actuatorId: string }): Promise<Actuator> => {
        const actuatorData = await actuatorRepository.deleteActuator(payload.actuatorId);
        return Actuator.parseFromObject(actuatorData);
    }
};

const mutations = {
    saveAllActuators: (state: ActuatorState, payload: { actuators: Actuator[] }) => {
        state.allActuators = payload.actuators;
    },
    updateActuator: (state: ActuatorState, payload: { actuator: Actuator }) => {
        const foundIndex = state.allActuators.findIndex((element: Actuator) => element.id === payload.actuator.id);
        if (foundIndex >= 0) {
            Object.assign(state.allActuators[foundIndex], payload.actuator);
        } else {
            state.allActuators.push(payload.actuator);
        }
    }
};

const getters = {
    allActuators: (state: ActuatorState) => {
        return state.allActuators;
    }
};

const actuatorStore: Module<any, any> = {
    namespaced: true,
    state: store,
    actions,
    mutations,
    getters
};

export default actuatorStore;
